// Cloudinary configuration and utility functions

// Replace with your Cloudinary cloud name and upload preset
// You'll need to create an unsigned upload preset in your Cloudinary dashboard
const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dgfexk1y2';
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'hotel_uploads';

// Function to upload image to Cloudinary
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  
  try {
    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }
    
    const data = await response.json();
    return {
      url: data.secure_url,
      publicId: data.public_id,
      width: data.width,
      height: data.height
    };
  } catch (error) {
    console.error('Error uploading image to Cloudinary:', error);
    throw error;
  }
};

// Function to optimize image URL with transformations
export const getOptimizedImageUrl = (imageUrl, width = 800, height = 600, quality = 'auto') => {
  if (!imageUrl || !imageUrl.includes('cloudinary.com')) {
    return imageUrl;
  }
  
  // Extract base URL and file path
  const parts = imageUrl.split('/upload/');
  if (parts.length !== 2) return imageUrl;
  
  return `${parts[0]}/upload/w_${width},h_${height},q_${quality}/${parts[1]}`;
};
